import pvhApi from '@/api/pvhApi'

import router from '@/router'

const state = () => ({
  client: {
    name: '',
    surname: '',
    patronymic: '',
    address: '',
    phone: '',
    email: '',
    informer: { id: null, name: '' },
    comment: ''
  },
  informTypeOptionList: [],
  validation: {
    name: { type: null, message: '' },
    phone: { type: null, message: '' }
  },
  isLoading: true
})

const getters = {
  '[pvh] getClientForUpdate': state => state.client,
  '[pvh] getClientUpdateValidation': state => state.validation,
  '[pvh] getClientUpdateIsLoading': state => state.isLoading,
  '[pvh] getClientInformerList': state => state.informTypeOptionList
}

const mutations = {
  '[pvh] GET_CLIENT': (state, client) => {
    state.client = client
  },
  '[pvh] GET_CLIENT_FOR_UPDATE': (state, client) => {
    state.client = {
      ...client,
      informer: client.informer ? {
        name: client.informer.name,
        id: client.informer.id
      } : null

    }
    state.isLoading = false
  },
  '[pvh] GET_CLIENT_INFORMER_LIST': (state, informer) => {
    state.informTypeOptionList = informer.data.map(informer => {
      return {
        ...informer
      }
    })
  },
  '[pvh] SET_CLIENT_UPDATE_NAME': (state, value) => {
    state.client.name = value
  },
  '[pvh] SET_CLIENT_UPDATE_SURNAME': (state, value) => {
    state.client.surname = value
  },
  '[pvh] SET_CLIENT_UPDATE_PATRONYMIC': (state, value) => {
    state.client.patronymic = value
  },
  '[pvh] SET_CLIENT_UPDATE_INFORMER': (state, informer) => {
    state.client.informer = informer
  },
  '[pvh] SET_CLIENT_UPDATE_ADDRESS': (state, value) => {
    state.client.address = value
  },
  '[pvh] SET_CLIENT_UPDATE_PHONE': (state, value) => {
    state.client.phone = value
  },
  '[pvh] SET_CLIENT_UPDATE_COMMENT': (state, value) => {
    state.client.comment = value
  },
  '[pvh] SET_CLIENT_UPDATE_EMAIL': (state, value) => {
    state.client.email = value
  },

  '[pvh] SET_CLIENT_ITEM_VALIDATION': (state, valid) => {
    if (valid?.name) {
      state.validation.name.message = valid.name[0]
      state.validation.name.type = 'error'
    }
    if (valid?.phone) {
      state.validation.phone.message = valid.phone[0]
      state.validation.phone.type = 'error'
    }
  },

  '[pvh] CLIENT_UPDATE_CLEAR_VALIDATION': (state, inputName) => {
    // свитч кейсом очищать валидацию в нужном поле по имени инпута
    switch (inputName) {
      case 'name':
        state.validation.name = { type: null, message: '' }
        break
      case 'phone':
        state.validation.phone = { type: null, message: '' }
        break
      default:
        break
    }
  },

  '[pvh] SET_CLIENT_UPDATE_INITIAL_STATE': (state) => {
    state.client = {
      name: '',
      surname: '',
      patronymic: '',
      address: '',
      phone: '',
      email: '',
      informer: { id: null, name: '' },
      comment: ''
    }
  }

}

const actions = {
  '[pvh] getClientUpdateInfo' ({ commit, state }, id) {
    const params = {
      expands: 'expand=informer',
      id
    }

    pvhApi.getClientUpdateInfo(params).then(response => {
      commit('[pvh] GET_CLIENT_FOR_UPDATE', response.data.data)
    }).catch(error => {
      console.log('ошибка получения клиента', error)
    })
  },
  '[pvh] clientUpdateSetName' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_NAME', value)
  },
  '[pvh] clientUpdateSetSurname' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_SURNAME', value)
  },
  '[pvh] clientUpdateSetPatronymic' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_PATRONYMIC', value)
  },
  '[pvh] clientUpdateSetAddress' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_ADDRESS', value)
  },
  '[pvh] clientUpdateSetPhone' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_PHONE', value)
  },
  '[pvh] clientUpdateSetInformer' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_INFORMER', value)
  },
  '[pvh] clientUpdateSetComment' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_COMMENT', value)
  },
  '[pvh] clientUpdateSetEmail' ({ commit }, value) {
    commit('[pvh] SET_CLIENT_UPDATE_EMAIL', value)
  },

  '[pvh] clientUpdateClearValidation' ({ commit }, inputName) {
    commit('[pvh] CLIENT_UPDATE_CLEAR_VALIDATION', inputName)
  },
  '[pvh] clientUpdateSaveInfo' ({ commit, state }, id) {
    const clientData = {
      name: state.client.name,
      surname: state.client.surname,
      patronymic: state.client.patronymic,
      address: state.client.address,
      phone: state.client.phone,
      email: state.client.email,
      informer_id: state.client.informer?.id,
      comment: state.client.comment
    }
    if (id === 'create') {
      pvhApi.postClientUpdateSaveInfo(clientData).then(response => {
        router.push({ name: 'PvhClientList' })
      }).catch(error => {
        commit('[pvh] SET_CLIENT_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления клиента', error.response)
      })
    } else {
      pvhApi.putClientUpdate(clientData, id).then(response => {
        router.push({ name: 'PvhClientList' })
      }).catch(error => {
        commit('[pvh] SET_CLIENT_ITEM_VALIDATION', error.response.data.validation)
        console.log('Ошибка обновления клиента', error.response)
      })
    }
  },
  '[pvh] getClientInformerOptions' ({ commit }) {
    const params = {
      searchFilter: '',
      currentTake: '',
      currentPage: ''
    }
    pvhApi.getInformType(params).then(response => {
      commit('[pvh] GET_CLIENT_INFORMER_LIST', response.data)
    })
  },
  '[pvh] setClientUpdateInitialState' ({ commit, state }) {
    commit('[pvh] SET_CLIENT_UPDATE_INITIAL_STATE', state)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
